//  Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { validFavoriteRadioCode } from 'helpers/regex'
import { validateRadioCode } from 'validators/common'

const validateFavoriteRadioCodeOrRadioCode = (v, required = false) => (
  v.includes('-')
    // a hyphen indicates that we should be looking at a favoriteRadioCode and not a radioCode
    // if it doesn't match the format for a valid favoriteRadioCode, tell em!
    ? v.match(validFavoriteRadioCode) === null && 'Invalid format for Radio Favorite Code.'
    // if there was no hyphen, then we should be looking at a radioCode
    : validateRadioCode(v, required)
)

export default validateFavoriteRadioCodeOrRadioCode
